import { CheckEmail } from "@/components/Login/CheckEmail";

export function CheckEmailPage() {
  return <CheckEmail />;
}
